"use client"

import Link from "next/link"
import { LiquidCtaButton } from "@/components/buttons/liquid-cta-button"
import { Building2, ArrowLeft, MapPin, Phone } from "lucide-react"
import { motion } from "framer-motion"

export function HeroSection() {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-6 pt-24 pb-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-brand/10 via-transparent to-transparent" />
      <div className="absolute inset-0 bg-[url('/properties/property-2/img-1.jpg')] bg-cover bg-center opacity-10" />

      <div className="relative z-10 text-center max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-gradient-to-r from-brand/30 to-brand/30 border border-brand/50 mb-8"
        >
          <div className="flex items-center gap-2">
            <Building2 className="w-4 h-4 text-brand-light animate-pulse" />
            <span className="text-sm text-brand-light font-medium">بنايه للعقارات</span>
          </div>
          <div className="h-4 w-px bg-brand/50" />
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4 text-brand-light" />
            <span className="text-sm text-zinc-300">مشاريع عقارية متميزة في مصر</span>
          </div>
        </motion.div>

        <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6">
          <span className="text-zinc-100 block mb-2">نبني أحلامك</span>
          <span className="bg-gradient-to-r from-brand via-brand-light to-brand bg-clip-text text-transparent">
            بأعلى معايير الجودة
          </span>
        </h1>

        <p className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto mb-10 leading-relaxed text-balance">
          شركة بنايه للعقارات - نقدم لكم أفضل العقارات السكنية بتصميمات عصرية وتشطيبات فاخرة ومواقع استراتيجية متميزة
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link href="https://wa.me/201212129070" target="_blank">
            <LiquidCtaButton>تواصل معنا عبر واتساب</LiquidCtaButton>
          </Link>
          <Link
            href="#properties"
            className="group flex items-center gap-2 px-6 py-3 text-sm font-medium text-zinc-400 hover:text-zinc-100 transition-colors"
          >
            <Building2 className="w-4 h-4" />
            <span>استعرض عقاراتنا</span>
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-300" />
          </Link>
        </div>

        <div className="mt-16 flex flex-col items-center gap-6">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {["شقق سكنية", "فيلات", "دوبلكس", "تشطيبات فاخرة", "مواقع متميزة", "أسعار تنافسية"].map((tag) => (
              <span
                key={tag}
                className="px-4 py-2 text-sm text-zinc-400 bg-zinc-900/50 border border-zinc-800 rounded-full hover:border-brand/50 hover:text-brand-light transition-all"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-6 text-sm text-zinc-500">
            <Link href="tel:+201212129070" className="flex items-center gap-2 hover:text-brand-light transition-colors">
              <Phone className="w-4 h-4" />
              <span dir="ltr">+20 12 12129070</span>
            </Link>
            <div className="h-4 w-px bg-zinc-800" />
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-brand-light" />
              <span className="text-brand-light">مصر</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
